import { Injectable } from "@angular/core";
import { AdditionalSettings } from "@core-models/additional-settings.model";

@Injectable({ providedIn: 'root' })
export class SettingsManager
{
  private _minPasswordLength: number = 12;
  private _maxPasswordLength: number = 120;
  private _minAcceptablePasswordStrength: number = 3;
  private _maintenanceData: AdditionalSettings.IMaintenanceData;
  private _isSiteEnabled: boolean = true;

  private _purchaseSuggestionPageEnabled: boolean = false;
  private _maxItems: number = 0;
  private _maxSuggestionsLimit: number = 0;

  private _isChatIconEnabled: boolean = false;
  private _isAivoChatbotEnabled: boolean = false;
  private _isWhatsAppIconEnabled: boolean = false;

  constructor() { }

  public set setMaintenanceData(value: AdditionalSettings.IMaintenanceData)
  {
    this._maintenanceData = value;
  }

  public get maintenanceData(): AdditionalSettings.IMaintenanceData
  {
    return this._maintenanceData;
  }
  // ********************************************************************
  // #region Min Acceptable Password Strength
  // ********************************************************************
  public set setMinAcceptablePasswordStrength(value: number)
  {
    this._minAcceptablePasswordStrength = value;
  }

  public get minAcceptablePasswordStrength(): number
  {
    return this._minAcceptablePasswordStrength;
  }

  // ********************************************************************
  // #endregion Min Acceptable Password Strength
  // ********************************************************************

  // ********************************************************************
  // #region Min Password Length
  // ********************************************************************
  public set setMinPasswordLength(value: number)
  {
    this._minPasswordLength = value;
  }

  public get minPasswordLength(): number
  {
    return this._minPasswordLength;
  }

  // ********************************************************************
  // #endregion Min Password Length
  // ********************************************************************

  // ********************************************************************
  // #region Max Password Length
  // ********************************************************************
  public set setMaxPasswordLength(value: number)
  {
    this._maxPasswordLength = value;
  }

  public get maxPasswordLength(): number
  {
    return this._maxPasswordLength;
  }

  // ********************************************************************
  // #endregion Max Password Length
  // ********************************************************************


  public set setSiteEnabled(value: boolean)
  {
    this._isSiteEnabled = value;
  }

  public get isSiteEnabled(): boolean
  {
    return this._isSiteEnabled;
  }

  public set setChatIconEnabled(value: boolean)
  {
    this._isChatIconEnabled = value;
  }

  public get isChatIconEnabled(): boolean
  {
    return this._isChatIconEnabled;
  }

  public set setWhatsappIconEnabled(value: boolean)
  {
    this._isWhatsAppIconEnabled = value;
  }

  public get isWhatsAppIconEnabled(): boolean
  {
    return this._isWhatsAppIconEnabled;
  }

  public set setIsAivoChatbotEnabled(value: boolean)
  {
    this._isAivoChatbotEnabled = value;
  }

  public get isAivoChatbotEnabled(): boolean
  {
    return this._isAivoChatbotEnabled;
  }

  public set setItemsLimit(value: number)
  {
    this._maxItems = value;
  }

  public get itemsLimit(): number
  {
    return this._maxItems;
  }

  public set setSuggestionsLimit(value: number)
  {
    this._maxSuggestionsLimit = value;
  }

  public get suggestionsLimit(): number
  {
    return this._maxSuggestionsLimit;
  }

  public set setPurchaseSuggestionPageEnabled(value: boolean)
  {
    this._purchaseSuggestionPageEnabled = value;
  }

  public get purchaseSuggestionPageEnabled(): boolean
  {
    return this._purchaseSuggestionPageEnabled;
  }
}
